import multiSchoolAccountModalEn from "./locales/en.json";

export const MULTI_SCHOOL_ACCOUNT_MODAL_NS = "multiSchoolAccountModal" as const;

export const MultiSchoolAccountModalI18n = {
  en: {
    [MULTI_SCHOOL_ACCOUNT_MODAL_NS]: {
      ...multiSchoolAccountModalEn,
    },
  },
};
